import useSuspenseQuery from 'commons/useSuspenseQuery';
import cleanObjectFromEmptyValues from 'commons/cleanObjectFromEmptyValues';
import { ALL_CUSTOMER_PHOTOS_AND_REVIEWS } from '../queries';

const useProductCustomerPhotosReviews = (id, options = {}) => {
  const { loading, error, data } = useSuspenseQuery(
    ALL_CUSTOMER_PHOTOS_AND_REVIEWS,
    {
      variables: cleanObjectFromEmptyValues({ id }),
      skip: !id,
      ssr: options.ssr ?? true,
    }
  );

  return {
    loading,
    error,
    data: {
      customerReviews: data?.allCustomerPhotosAndReviews?.reviews,
      customerPhotos: data?.allCustomerPhotosAndReviews?.customer_photos,
    },
  };
};

export default useProductCustomerPhotosReviews;
